module.exports = __webpack_public_path__ + "static/media/outsourced-delivery.53804227.svg";